module.exports = __webpack_public_path__ + "static/FSgrey-76bd4a5b787c8f222805e61800bded60.png";